import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { CustomButton } from '@fw-nextgen/fw-components';

import routerStore from '@app/src/common/store/RouterStore';
import ErrorIcon from '@app/src/assets/error-404.svg';

import './ErrorPage.scss';

interface IErrorPage {
  errorCode?: string;
  error?: string;
  message: string;
}

const ErrorPage = ({ errorCode, message, error = 'error' }: IErrorPage) => {
  const history = useHistory();
  routerStore.targetPath = null;
  const onClick = () => history.push('/');

  return (
    <div className="error-page__wrapper">
      <div className="error-page">
        <div className="error-page__img">
          <ErrorIcon />
        </div>
        <div className="error-page__info">
          <FormattedMessage id={error}>
            {text => (
              <h2>
                {text} {errorCode}
              </h2>
            )}
          </FormattedMessage>
          <FormattedMessage id={message} tagName="p" />
        </div>
        <CustomButton
          className="error-page__button"
          value="button.to.home"
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default ErrorPage;
